import React from "react";
import {MiniMapWithTiles} from "./MiniMapWithTiles";

export const MiniMapWidget = ({layers, locationInfos}) => {

    return (
        <div className="dashboard__body__map__container">
            <MiniMapWithTiles
                layers={layers}
                locationInfos={locationInfos}
                outlineCity={{
                    "type": "FeatureCollection",
                    "features": [
                        {"type": "Feature", "geometry": {"type": "Point","coordinates": [locationInfos.address.lon, locationInfos.address.lat]}, "properties": {}}
                    ]
                }}
            />
        </div>
    )
}